import { Box, Chip, TextField } from '@mui/material';

const QUICK_ADD_ADDRESSES = ['dbrsales@dbr-sys.com', 'dbrsystems@dbr-sys.com'];

interface CcFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  /** Seven Seas: CC stays empty, their portal rejects anything but a bare reply. */
  locked: boolean;
}

/** The editable CC line, with one-click adds for DBR's own mailboxes. */
export default function CcField({ value, onChange, disabled, locked }: CcFieldProps) {
  const quickAdd = (email: string) => {
    const currentEmails = value.trim();
    if (currentEmails && !currentEmails.endsWith(',')) {
      onChange(currentEmails + ', ' + email);
    } else if (currentEmails.endsWith(',')) {
      onChange(currentEmails + ' ' + email);
    } else {
      onChange(email);
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        label="CC"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        margin="dense"
        disabled={disabled || locked}
        placeholder={locked ? 'No CC — Seven Seas requires a bare reply' : 'Quick add: dbrsales@dbr-sys.com or dbrsystems@dbr-sys.com, or type manually'}
        helperText={locked ? 'Seven Seas: do not CC the user inside' : 'Separate multiple email addresses with commas'}
      />
      {!locked && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
          {QUICK_ADD_ADDRESSES.map((email) => (
            <Chip
              key={email}
              label={`+ ${email}`}
              variant="outlined"
              size="small"
              onClick={() => quickAdd(email)}
              disabled={disabled}
              sx={{
                color: 'text.secondary',
                borderColor: 'divider',
                '&:hover': {
                  backgroundColor: 'action.hover',
                  borderColor: 'primary.main'
                }
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
